import './ccf-conversation-outline-icon.module.scss';
import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfConversationOutlineIconProps extends SvgIconProps  {}
/**
 * component used to display conversation outline icon
 * @param props - CcfConversationOutlineIconProps
 * @example - <CcfConversationOutlineIcon />
 * @returns SVG of conversation outline icon
 */
export function CcfConversationOutlineIcon(
  props: CcfConversationOutlineIconProps
) {
  return (
    <SvgIcon width="32" height="32" viewBox="0 0 32 32" {...props}>
      <g
        id="ic_conversations_outline"
        clip-path="url(#clip-ic_conversations_outline)"
      >
        <g id="ic_conversations" transform="translate(1.947 4.608)">
          <path
            id="chat-inbound"
            d="M129.371-42h-5.215A6.133,6.133,0,0,0,118-35.891v.106a6.134,6.134,0,0,0,6.156,6.109h2.509l5.374,3.86a.546.546,0,0,0,.574.02.53.53,0,0,0,.262-.452l-.8-4.07a6.087,6.087,0,0,0,3.454-5.465v-.106A6.131,6.131,0,0,0,129.371-42Z"
            transform="translate(-107.421 48.51)"
            strokeWidth="2"
          />
          <path
            id="chat-inbound-2"
            data-name="chat-inbound"
            d="M125.431-42h6.3a7.4,7.4,0,0,1,7.431,7.375v.127a7.4,7.4,0,0,1-7.431,7.375H128.7l-6.487,4.66a.659.659,0,0,1-.693.024.64.64,0,0,1-.317-.545l.968-4.913a7.348,7.348,0,0,1-4.17-6.6v-.127A7.4,7.4,0,0,1,125.431-42Z"
            transform="translate(-118 42)"
            strokeWidth="2"
          />
        </g>
      </g>
    </SvgIcon>
  );
}

export default CcfConversationOutlineIcon;
